<template>
  <div>
    <!-- 与操作按钮相分隔开的内容 -->
    <div>
      <!-- 基础信息 -->
      <div
        style="
          border: 1px solid #ddd;
          margin-top: 20px;
          padding: 0 20px;
          color: #666;
          font-size: 15px;
          width: 100%;
        "
      >
        <div style="font-size: 20px; margin: 8px 0 20px 0">基础信息</div>
        <div class="prCon">
          <div class="childCon">
            <span class="childMt">客户姓名:</span>
            <span>{{ taskDetail.contacts }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">订单状态:</span>
            <span>{{ taskDetail.states }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">订单号:</span>
            <span>{{ taskDetail.order_id }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">店铺:</span>
            <span>{{ taskDetail.store_name }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">负责店长:</span>
            <span>{{ taskDetail.username }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">下单时间:</span>
            <span>{{ taskDetail.created_time }}</span>
          </div>
        </div>
        <div class="prCon">
          <div class="childCon">
            <span class="childMt">联系电话:</span>
            <span>{{ taskDetail.telephone }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">订单来源:</span>
            <span
              v-if="
                taskDetail.channelTitle == null || taskDetail.channelTitle == ''
              "
              >{{ taskDetail.channel }}</span
            >
            <span v-else
              >{{ taskDetail.channel }}-{{ taskDetail.channelTitle }}</span
            >
          </div>
          <div class="childCon">
            <span class="childMt">房屋问题:</span>
            <span>{{ taskDetail.problemTitle }}</span>
          </div>
          <div class="childCon">
            <span class="childMt">添加微信:</span>
            <span v-if="taskDetail.wechat == 1">是</span>
            <span v-else>否</span>
          </div>
          <div class="childCon2">
            <span class="childMt">维修地址:</span>
            <span>{{ taskDetail.addres }}</span>
          </div>
        </div>
        <div class="prCon">
          <div class="childCon3">
            <span class="childMt">备注信息:</span>
            <span>{{ taskDetail.remarks }}</span>
          </div>
        </div>
      </div>
      <!-- 打卡未报价任务 -->
      <div
        style="
          border: 1px solid #ddd;
          margin-top: 20px;
          padding: 0 20px;
          color: #666;
          font-size: 15px;
          width: 100%;
        "
      >
        <div style="font-size: 20px; margin: 8px 0 20px 0">打卡未报价任务</div>
        <div class="prCon">
          <div class="childCon7">
            <span class="childMt">超时时间:</span>
            <span>{{ taskDetail1.overtime }}</span>
          </div>
          <div class="childCon7">
            <span class="childMt">下单时间:</span>
            <span>{{ taskDetail.created_time }}</span>
          </div>
          <div class="childCon7">
            <span class="childMt">派单时间:</span>
            <span>{{ taskDetail.time }}</span>
          </div>
          <div class="childCon7">
            <span class="childMt">打卡时间:</span>
            <span>{{ taskDetail1.punch_clock }}</span>
          </div>
          <div class="childCon7">
            <span class="childMt">打卡位置:</span>
            <span>{{ taskDetail1.address }}</span>
          </div>
        </div>
      </div>
      <!-- 处理记录 -->
      <div
        style="
          border: 1px solid #ddd;
          margin-top: 20px;
          padding: 0 20px;
          color: #666;
          font-size: 15px;
          width: 100%;
          margin-bottom: 10px;
        "
      >
        <div style="font-size: 20px; margin-top: 8px">处理记录</div>
        <avue-crud :data="dealRecord" :option="option2">
          <template slot-scope="scope" slot="tagging">
            <span v-if="scope.row.tagging == 1">其他方式已报价</span>
            <span v-if="scope.row.tagging == 2">客户没意向</span>
            <span v-if="scope.row.tagging == 3">店长即将报价</span>
            <span v-if="scope.row.tagging == 4">其他</span>
            <span v-if="scope.row.tagging == 5">转派店长</span>
          </template>
        </avue-crud>
      </div>
      <!-- 沟通记录表格 -->
      <div
        style="
          border: 1px solid #ddd;
          margin-top: 20px;
          padding: 0 20px;
          color: #666;
          font-size: 15px;
          width: 100%;
          margin-bottom: -80px;
        "
      >
        <div style="font-size: 20px; margin-top: 8px">沟通记录</div>
        <avue-crud :data="connectRecord" :option="option1">
          <template slot-scope="scope" slot="conversation">
            <span v-if="scope.row.conversation == 0">是</span>
            <span v-if="scope.row.conversation == 2">否</span>
          </template>
          <template slot-scope="scope" slot="record">
            <div v-if="scope.row.record.length == 0">暂无录音</div>
            <div v-else>
              <audio
                style="width: 100%; outline: none"
                :src="scope.row.record[0].monitorfilename"
                controls="controls"
              ></audio>
            </div>
          </template>
          <template slot="log" slot-scope="scope">
            <span v-if="scope.row.log.length == 0">暂无图片</span>
            <div v-else>
              <img
                v-for="(item, index) in scope.row.log"
                :src="item.value"
                :key="index"
                style="width: 50px; height: 50px; margin-right: 2px"
              />
            </div>
          </template>
        </avue-crud>
      </div>
    </div>
    <!-- 底部操作按钮 -->
    <div
      style="
        background: #dae1e6;
        display: flex;
        padding: 2% 0 2% 7%;
        margin: 2% 0 0 -3% !important;
        position: fixed;
        width: 80%;
        left: 274px;
        bottom: 0;
        z-index: 99;
      "
    >
      <div
        style="
          padding-right: 5%;
          margin-right: 5%;
          border-right: 1px solid white;
        "
      >
        <el-button type="primary" size="medium" plain @click="openFinish"
          >任务完成</el-button
        >
        <el-button type="warning" size="medium" plain @click="finishSetting"
          >取消挂起</el-button
        >
        <el-button
          @click="addWechat"
          style="color: red"
          size="medium"
          v-if="taskDetail.wechat == 1"
          >加微信标记(已添加)</el-button
        >
        <el-button type="primary" size="medium" plain @click="addWechat" v-else
          >加微信标记(未添加)</el-button
        >
      </div>
      <div>
        <el-button
          v-if="wiahulema2"
          type="success"
          size="medium"
          plain
          @click="waihu('dian')"
          >外呼{{ waihudian.username }}店长</el-button
        >
        <el-button v-else-if="!wiahulema2" type="danger" size="medium" plain
          >呼叫中</el-button
        >
        <el-button
          v-if="wiahulema"
          type="warning"
          size="medium"
          plain
          @click="waihu"
          >外呼客户</el-button
        >
        <el-button v-else-if="!wiahulema" type="danger" size="medium" plain
          >呼叫中</el-button
        >
        <el-button type="primary" size="medium" plain @click="lookOrigin"
          >查看原始订单</el-button
        >
        <el-button type="primary" size="medium" plain @click="openDeliver"
          >任务转派</el-button
        >
      </div>
    </div>
    <!-- 超时未接单任务完成模态框 -->
    <el-dialog
      title="任务完成"
      :visible.sync="finishDialog1"
      width="45%"
      z-index="100"
      center
      top="10%"
    >
      <div style="display: flex; padding: 0 15% 5% 12%">
        <div
          style="margin-right: 5%; width: 130px; font-size: 16px; color: #999"
        >
          处理详情
        </div>
        <div>
          <el-radio-group v-model="radio1" style="margin-bottom: 40px">
            <el-radio :label="1" class="radioStyle">其他方式已报价</el-radio>
            <el-radio :label="2" class="radioStyle">客户没意向</el-radio>
            <el-radio :label="3" class="radioStyle">店长即将报价</el-radio>
            <el-radio :label="4" class="radioStyle2">其他</el-radio>
            <el-radio :label="5" class="radioStyle2">转派店长</el-radio>
          </el-radio-group>
          <el-input
            type="textarea"
            placeholder="请输入备注内容"
            v-model="textarea1"
            style="width: 90%; margin-bottom: 20px"
          >
          </el-input>
          <el-select
            v-model="shopper"
            placeholder="请选择转派店长"
            v-if="radio1 == 5"
            style="width: 90%"
            filterable
          >
            <el-option
              v-for="(item, index) in shoppers"
              :key="index"
              :label="item.usernamestorename"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
          <div
            class="blocks2 flex_items flex_start"
            style="margin-top: 20px"
            v-if="radio1 == 5"
          >
            <span class="mr20" style="margin-right: 25px">发送短信</span>
            <el-checkbox-group v-model="sendMsg">
              <el-checkbox label="店长"></el-checkbox>
              <!-- <el-checkbox label="客户"></el-checkbox> -->
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="finishDialog1 = false"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" plain @click="finishTask"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 超时未接单任务挂起/设置跟进模态框 -->
    <el-dialog
      title="任务挂起/设置跟进"
      :visible.sync="finishDialog2"
      width="45%"
      z-index="100"
      center
      top="10%"
    >
      <div style="display: flex; padding: 0 13% 5% 18%">
        <el-form :model="form1">
          <div
            class="blocks2 flex_items flex_start"
            style="margin-bottom: 20px; margin-right: 1%; padding-left: 3px"
          >
            <span style="width: 85px; margin-right: 15px">下次跟进时间</span>
            <el-date-picker
              :clearable="true"
              v-model="form1.orderTime"
              type="datetime"
              placeholder="选择下次跟进时间"
              style="width: 300px"
            ></el-date-picker>
          </div>
          <el-form-item
            label="跟进原因"
            :label-width="formLabelWidth"
            prop="reasonArr"
          >
            <el-cascader
              change-on-select
              :props="defaultParams"
              v-model="form1.reasonArr"
              :options="options"
              filterable
              clearable
              class="casStyle"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="跟进备注" :label-width="formLabelWidth">
            <el-input
              v-model="form1.remark"
              type="textarea"
              placeholder="请输入备注内容"
              autocomplete="off"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="沟通方式" :label-width="formLabelWidth">
            <el-select
              v-model="form1.mode"
              placeholder="请选择沟通方式"
              style="width: 300px"
            >
              <el-option
                v-for="item in modes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="finishDialog2 = false"
          >取 消</el-button
        >
        <el-button type="warning" size="medium" plain @click="finishSetting"
          >取消挂起</el-button
        >
      </span>
    </el-dialog>
    <!-- 超时未接单任务转派模态框 -->
    <el-dialog
      title="任务转派"
      :visible.sync="finishDialog3"
      width="45%"
      z-index="100"
      center
      top="10%"
    >
      <div style="display: flex; padding: 0 13% 5% 18%">
        <el-form :model="form2">
          <el-form-item label="转派客服" :label-width="formLabelWidth">
            <el-select
              v-model="form2.customer"
              placeholder="请选择转派客服"
              style="width: 300px"
              :clearable="true"
            >
              <el-option
                v-for="(item, index) in clients"
                :key="index"
                :label="item.username"
                :value="item.admin_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="finishDialog3 = false"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" plain @click="finishDeliver"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看原始订单 -->
    <el-dialog
      :visible.sync="dialogTableVisibleLook"
      width="70%"
      :close-on-click-modal="false"
    >
      <Detailes2></Detailes2>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["parentRow"],
  data() {
    return {
      //任务详细信息
      taskDetail: {
        contacts: "张三",
        state: "一个状态",
        order_id: 202107141422,
        store_name: "金沙店",
        username: "李华",
        created_time: "1994-02-23 00:00:00",
        telephone: 15182996821,
        channel: "推客宝盒",
        problemTitle: "墙面翻新",
        wechat: 1,
        addres: "四川省成都市金牛区万通金融广场西塔",
        remarks: "这是一个备注呢，多写几个字",
      },
      //打卡未报价
      taskDetail1: {},
      connectRecord: [],
      dealRecord: [],
      option1: {
        size: "medium",
        menu: false,
        page: false,
        align: "left",
        dateBtn: false,
        dateDefault: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        columnBtn: false, //列动态显隐按钮
        refreshBtn: false, // 刷新按钮
        column: [
          // {
          //   label: "时间",
          //   prop: "th_time",
          //   type: "date",
          //   format: "yyyy-MM-dd hh:mm:ss",
          //   valueFormat: "yyyy-MM-dd hh:mm:ss",
          // },
          {
            label: "处理人",
            prop: "username",
          },
          {
            label: "方式",
            prop: "mode",
          },
          {
            label: "是否接通",
            prop: "conversation",
            slot: true,
          },
          {
            label: "沟通内容",
            prop: "remar",
          },
          {
            label: "沟通录音",
            prop: "record",
            slot: true,
          },
          {
            label: "跟进时间",
            prop: "th_time",
            type: "date",
            format: "yyyy-MM-dd hh:mm:ss",
            valueFormat: "yyyy-MM-dd hh:mm:ss",
          },
          {
            label: "下次跟进",
            prop: "end_time",
            type: "date",
            format: "yyyy-MM-dd hh:mm:ss",
            valueFormat: "yyyy-MM-dd hh:mm:ss",
          },
          {
            label: "图片",
            prop: "log",
            type: "upload",
            imgFullscreen: true,
            imgType: "card",
            width: "200px",
            listType: "picture-card",
          },
        ],
      },
      option2: {
        size: "medium",
        menu: false,
        page: false,
        align: "left",
        dateBtn: false,
        dateDefault: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        columnBtn: false, //列动态显隐按钮
        refreshBtn: false, // 刷新按钮
        column: [
          {
            label: "时间",
            prop: "time",
            width: "200px",
          },
          {
            label: "处理人",
            prop: "username",
            width: "200px",
          },
          {
            label: "处理详情",
            prop: "tagging",
            slot: true,
          },
          {
            label: "备注",
            prop: "reason",
          },
        ],
      },
      finishDialog1: false,
      radio1: 2,
      shopper: "",
      shoppers: [],
      textarea1: "",
      sendMsg: ["店长"],
      finishDialog2: false,
      orderTime: "",
      form1: {
        reasonArr: [],
        orderTime: "",
        mode: "",
        reason: "",
        remark: "",
      },
      formLabelWidth: "100px",
      form2: {
        customer: "",
      },
      finishDialog3: false,

      options: [],
      defaultParams: {
        label: "title",
        value: "title",
        children: "children",
      },
      clients: [],
      dialogTableVisibleLook: false,
      waihudian: { username: "", mobile: "" },
      wiahulema: true,
      wiahulema2: true,
      waihulun: 0,
      isSaveState: true,
      ExternalData: "",
      call: [],
      //  沟通方式
      modes: [
        {
          value: "电话",
          label: "电话",
        },
        {
          value: "微信",
          label: "微信",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
    };
  },
  mounted() {
    this.getclient();
    this.getProductType();
    this.getShopper();
    this.getDetail();
  },
  methods: {
    getShopper() {
      //获取店长
      this.util
        .get(this.HOST + "/Common/user", {
          city_id: "",
          order_id: this.parentRow.order_id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.shoppers = res.data;
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },
    getclient() {
      // 获取客服
      this.util.get(this.HOST + "/Common/CustomerService", {}).then((res) => {
        if (res.code == 200) {
          this.clients = res.data;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
            duration: 1200,
            offset: 90,
          });
        }
      });
    },
    getDetail() {
      //获取任务详情
      this.$loading(this.util.opload);
      this.util
        .get(this.HOST + "/Order/TaskInfo", {
          cc_id: this.parentRow.cc_id,
          order_id: this.parentRow.order_id,
          type: this.parentRow.type,
        })
        .then((res) => {
          if (res.code == 200) {
            this.taskDetail = res.data;
            this.taskDetail1 = res.data.data[0];
            this.connectRecord = res.data.through;
            this.dealRecord = res.data.result;
            this.$loading().close();
          } else {
            this.$loading().close();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
      this.managerPhone();
    },
    managerPhone() {
      // 获取店长号码名字
      this.util
        .get(this.HOST + "/User/findShopOwner", {
          order_id: this.$store.state.order_id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.waihudian = res.data;
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },

    getProductType() {
      // 获取级联选择器数据
      this.util
        .get(this.HOST + "/Common/getRemote") // 这是从后台获取数据
        .then((res) => {
          if (res.code == 200) {
            // 调用递归方法，去除级联数据后将数据赋值给级联选择器
            this.options = this.getTreeData(res.data);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
    },
    getTreeData(data) {
      // 递归方法
      for (var i = 0; i < data.length; i++) {
        // 循环遍历json数据
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续递归调用本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    lookOrigin() {
      //查看原始订单
      this.dialogTableVisibleLook = true;
    },
    addWechat() {
      this.$loading(this.util.opload);
      let wechat = "";
      if (this.taskDetail.wechat == 1) {
        wechat = 0;
      } else {
        wechat = 1;
      }
      this.util
        .get(this.HOST + "/Order/SelectorSwitch", {
          order_id: this.parentRow.order_id,
          wechat: wechat,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "处理成功!",
              type: "success",
              duration: 1200,
              offset: 90,
            });
            this.getDetail();
            this.$loading().close();
          } else {
            this.$loading().close();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
      this.getDetail();
    },
    finishTask() {
      //任务完成处理模态框确认按钮
      let sms = 0;
      let sms1 = 0;
      if (this.sendMsg.length == 0) {
        sms = 0;
      } else {
        sms = 1;
      }
      if (this.radio1 == "") {
        this.$message({
          showClose: true,
          message: "请选择处理结果!",
          type: "error",
          duration: 1200,
          offset: 90,
        });
        return false;
      }
      if (
        (this.radio1 == 1 ||
          this.radio1 == 2 ||
          this.radio1 == 3 ||
          this.radio1 == 4) &&
        this.textarea1 == ""
      ) {
        this.$message({
          showClose: true,
          message: "请填写备注!",
          type: "error",
          duration: 1200,
          offset: 90,
        });
        return false;
      }
      if (this.radio1 == 5 && this.shopper == "") {
        this.$message({
          showClose: true,
          message: "请选择转派店长!",
          type: "error",
          duration: 1200,
          offset: 90,
        });
        return false;
      }
      this.util
        .post(this.HOST + "/Order/ProcessingTasks", {
          cc_id: this.parentRow.cc_id,
          order_id: this.parentRow.order_id,
          type: this.parentRow.type,
          reason: this.textarea1,
          tagging: this.radio1,
          user_id: this.shopper,
          sms1: sms1,
          sms: sms,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "处理成功!",
              type: "success",
              duration: 1200,
              offset: 90,
            });
            this.finishDialog1 = false;
            this.$parent.returnTaskList();
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
            this.finishDialog1 = false;
          }
        });
    },
    finishCancel() {},
    finishSetting() {
      // let time = this.util.datatime(this.form1.orderTime);
      //   if (this.form1.orderTime == null || time == "NaN-NaN-NaN NaN:NaN:NaN") {
      //   this.$message({
      //     showClose: true,
      //     type: "error",
      //     duration: 1200,
      //     message: "请选择跟进时间",
      //     offset:90
      //   });
      //   return false;
      // }
      // if (this.form1.reasonArr.length == 0) {
      //   this.$message({
      //     showClose: true,
      //     message: "请选择跟进原因!",
      //     type: "error",
      //     duration: 1200,
      //     offset: 300,
      //   });
      //   return false;
      // }
      // if (this.form1.remark == "") {
      //   this.$message({
      //     showClose: true,
      //     message: "请输入备注!",
      //     type: "error",
      //     duration: 1200,
      //     offset: 300,
      //   });
      //   return false;
      // }
      // if (this.form1.mode == "") {
      //   this.$message({
      //     showClose: true,
      //     message: "请选择沟通方式!",
      //     type: "error",
      //     duration: 1200,
      //     offset: 300,
      //   });
      //   return false;
      // }
      let hang_up = 0;
      if (this.parentRow.hang_up == 0) {
        hang_up = 1;
      } else if (this.parentRow.hang_up == 1) {
        hang_up = 0;
      }
      //设置挂起与跟进
      this.util
        .get(this.HOST + "/Cc/HangUp", {
          cc_id: this.parentRow.cc_id,
          order_id: this.parentRow.order_id,
          // end_time: time,
          // remar: this.form1.remark,
          // mode: this.form1.mode,
          // hang_up:this.parentRow.hang_up,
          hang_up: hang_up,
          // status: this.form1.reasonArr[0],
          // status1: this.form1.reasonArr[1],
          // status2: this.form1.reasonArr[2],
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "处理成功!",
              type: "success",
              duration: 1200,
              offset: 300,
            });
            this.finishDialog2 = false;
            this.$parent.returnTaskList();
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 300,
            });
            this.finishDialog2 = false;
          }
        });
    },
    waihu(aa) {
      // 发起外呼
      if (!this.wiahulema || !this.wiahulema2) {
        this.$message({
          showClose: true,
          message: "不能同时呼叫!",
          type: "warning",
          duration: 1200,
          offset: 90,
        });
        return false;
      }
      let phone = "";
      if (aa == "dian") {
        if (this.waihudian.username == "") {
          this.$message({
            showClose: true,
            message: "该订单暂未指派店长!",
            type: "warning",
            duration: 1200,
            offset: 90,
          });
          return false;
        } else {
          phone = this.waihudian.mobile;
        }
      } else {
        phone = this.waihudian.telephone;
      }
      // 打包后
      this.$jsonp(this.HOST4, {
        account: "N000000015324",
        appid: "ncvsorfw58bk2o6r",
        secret: "31792f00-d2e5-11e9-8be9-b3731625d6b2",
        output: "jsonp",
      }).then((res) => {
        if (res.success) {
          if (aa == "dian") {
            this.wiahulema2 = false;
          } else {
            this.wiahulema = false;
          }
          this.kaihu(res.accessToken, phone, aa);
        }
      });
    },
    kaihu(token, phone, aa) {
      let timestamp = new Date().getTime();
      let good = "customer";
      if (aa == "dian") {
        good = "shopowner";
      }
      let kk = timestamp + "-" + good;
      this.lunxun(kk);
      // 打包后
      this.$jsonp(this.HOST5, {
        phonenum: phone,
        integratedid: sessionStorage.getItem("integratedid"),
        accessToken: token,
        account: "N000000015324",
        flag: 106,
        ExternalData: "main:" + kk,
        output: "jsonp",
      }).then((res) => {
        if (res.success) {
          if (aa == "dian") {
            this.wiahulema2 = false;
          } else {
            this.wiahulema = false;
          }
        }
      });
    },
    lunxun(kk) {
      this.waihulun = 1;
      let that = this;
      let arr = [];
      that.iCount = window.setInterval(function () {
        that.$http
          .get(that.HOST + "/Callback/jie", {
            params: {
              ExternalData: kk,
            },
          })
          .then((res) => {
            if (res.data.code == 200) {
              that.waihulun = 0;
              that.wiahulema = true;
              that.wiahulema2 = true;
              that.isSaveState = true;
              that.call.push(res.data.data.id);
              clearInterval(that.iCount);
            } else {
              arr.push(res.data.code);
              if (arr.length == 35) {
                that.waihulun = 0;
                that.wiahulema = true;
                that.wiahulema2 = true;
                that.isSaveState = true;
                arr = [];
                clearInterval(that.iCount);
              }
            }
          })
          .catch(function (error) {
            // 请求失败处理
            window.console.log(error);
          });
      }, 2000);
    },
    openFinish() {
      this.finishDialog1 = true;
    },
    openSetting() {
      this.finishDialog2 = true;
    },
    openDeliver() {
      this.finishDialog3 = true;
    },
    handleChange() {},
    finishDeliver() {
      if (this.form2.customer == "") {
        this.$message({
          showClose: true,
          message: "未选择转派人!",
          type: "error",
          duration: 1200,
          offset: 90,
        });
        return false;
      }
      this.util
        .get(this.HOST + "/Cc/Task", {
          cc_id: this.parentRow.cc_id,
          admin_id: this.form2.customer,
          order_id: this.parentRow.order_id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "转派成功!",
              type: "success",
              duration: 1200,
              offset: 90,
            });
            this.$parent.returnTaskList();
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset: 90,
            });
          }
        });
      this.finishDialog3 = false;
    },
  },
  components: {
    Detailes2: () => import("@/components/detailes2.vue"),
  },
};
</script>
<style scoped>
.totalPr {
  background: white !important;
  padding-left: 25px;
  width: 96% !important;
}
.container {
  margin: 0 auto;
  background: white;
  padding: 40px 0 0 80px;
  border-radius: 8px;
  /* height: 100%; */
}
.blocks2 {
  margin-right: 20px;
  margin-top: 10px;
}
.abs {
  position: absolute;
}
.wuyekuang {
  top: 37px;
  left: 76px;
  width: 202px;
  list-style: none;
  z-index: 20000;
  overflow: hidden;
  max-height: 143px;
  padding: 6px 0;
  box-sizing: border-box;
  background: white;
  overflow-y: scroll;
  border: 1px solid #e4e7ed;
  color: #666;
}
.zanwu {
  padding: 10px 0;
  margin: 0;
  text-align: center;
  color: #999;
  font-size: 15px;
  top: 50px;
  left: 76px;
  width: 202px;
  box-sizing: border-box;
  background: white;
  border: 1px solid #e4e7ed;
  position: absolute;
  z-index: 999;
  cursor: pointer;
}
.box {
  padding: 30px 0 0 30px;
  background: white;
}
.prCon {
  display: flex;
  flex-wrap: wrap;
}
.childCon {
  width: 16%;
  margin-bottom: 40px;
}
.childCon2 {
  width: 32%;
  margin-bottom: 40px;
}
.childCon3 {
  width: 100%;
  margin-bottom: 20px;
}
.childCon4 {
  width: 24%;
  margin-bottom: 60px;
}
.childCon5 {
  width: 48%;
  margin-bottom: 60px;
}
.childCon6 {
  width: 24%;
  margin-bottom: 20px;
}
.childCon7 {
  width: 20%;
  margin-bottom: 20px;
}
.childCon8 {
  width: 60%;
  margin-bottom: 20px;
}
.childMt {
  margin-right: 8px;
}
.btnStyle {
  border: 1px solid #409eff;
  color: #409eff;
}
.avue-crud__menu {
  min-height: 4px !important;
}
.radioStyle {
  margin-bottom: 30px;
  width: 25%;
}
.radioStyle2 {
  width: 25%;
}
.casStyle {
  width: 300px !important;
}
</style>
